export const DRAWER_STACK_ACTIONS = {
  Clear: 'CLEAR',
  Close: 'CLOSE',
  Open: 'OPEN',
  ReplaceTop: 'REPLACE_TOP'
};
